import { useEffect } from "react";
import { useNavigate } from "react-router";

import { useSlug } from "@/hooks/useSlug";

export function RedirectToRoute<T extends boolean = false>({
  to,
  withSlug,
}: {
  to: T extends true ? (data: { slug: string }) => string : () => string;
  withSlug?: T;
}): React.ReactNode {
  const navigate = useNavigate();
  const slug = useSlug({ optional: !withSlug });

  useEffect(() => {
    void navigate(slug ? to({ slug }) : (to as () => string)(), { replace: true });
  }, [to, slug, navigate]);

  return null;
}
